import React from 'react'

import { findSegmentFromCursor, replaceSelection } from '../utils/selectionUtils'

import { UseEditorHandlersProps } from './useEditorHandlers'

export const handleKeyDownEditor = (
  e: React.KeyboardEvent<HTMLDivElement>,
  props: UseEditorHandlersProps,
) => {
  const { editorRef, isNavigating, selectAllContent } = props

  const selection = window.getSelection()
  if (!selection) return

  // Handle printable characters while in navigation mode with a selection
  if (isNavigating && !selection.isCollapsed && e.key.length === 1 && !e.metaKey && !e.ctrlKey) {
    e.preventDefault()
    replaceSelection(selection, editorRef, props, e.key)
    return
  }

  // Handle deletion of a selection
  if (
    (e.key === 'Backspace' || e.key === 'Delete') &&
    !selection.isCollapsed
  ) {
    e.preventDefault()
    replaceSelection(selection, editorRef, props)
    return
  }

  if (
    isNavigating &&
    selection.isCollapsed &&
    (e.key === 'Backspace' || e.key === 'Delete')
  ) {
    e.preventDefault()

    const { segments, elRefs, globalCursorPos } = props

    // Compute deletion range [startPos, endPos) in global coordinates
    const totalLength = segments.reduce((sum, s) => sum + s.content.length, 0)
    const startPos = e.key === 'Backspace' ? Math.max(0, globalCursorPos - 1) : globalCursorPos
    const endPos = e.key === 'Backspace' ? globalCursorPos : Math.min(totalLength, globalCursorPos + 1)

    if (startPos === endPos) {
      return
    }

    const startInfo = findSegmentFromCursor(startPos, segments)
    const endInfo = findSegmentFromCursor(endPos, segments)

    if (!startInfo || !endInfo) {
      return
    }

    const startEl = elRefs.current.get(startInfo.segment.id)
    const endEl = elRefs.current.get(endInfo.segment.id)

    if (!startEl || !endEl) {
      return
    }

    const range = document.createRange()
    range.setStart(startEl.firstChild || startEl, startInfo.localPos)
    range.setEnd(endEl.firstChild || endEl, endInfo.localPos)
    selection.removeAllRanges()
    selection.addRange(range)

    replaceSelection(selection, editorRef, props)
    return
  }

  // Select All is a global action
  if ((e.metaKey || e.ctrlKey) && e.key === 'a') {
    e.preventDefault()
    selectAllContent()
    return
  }

  // NOTE: The logic for transitioning from navigation to edit mode
  // is now handled automatically by a timer in the useNavigation hook.
  // This handler is now only responsible for global actions like "select all"
  // and deletion of a selection.
} 